import { forEach, isEmpty, isNil } from "lodash";
import { roundFte } from "src/util/roundingStrategy";
import { hashGrouping, setGroupingWithCalculatedSumTotals } from "./util";

export const setGroupingTotalFteSum = (
  grouping,
  columns,
  prefillWithIntersectingFte = false
) => {
  const { childGroupings, lineItems } = grouping;

  const summedTotalFtes = new Array(columns.length).fill(0);
  const lineItemTotalFtes = new Array(columns.length).fill(0);

  forEach(childGroupings, (childGrouping) => {
    const childrenGroupingTotals = setGroupingTotalFteSum(
      childGrouping,
      columns,
      prefillWithIntersectingFte
    );

    forEach(columns, (column, index) => {
      const totalFteSum = childrenGroupingTotals[index];
      summedTotalFtes[index] += totalFteSum;
    });
  });

  forEach(lineItems, (lineItem) => {
    const { cells } = lineItem;

    forEach(cells, (cell, index) => {
      const { currentFteSum } = cell;
      const fteSum = isNil(currentFteSum) ? 0 : currentFteSum;
      // Set fte sum back, in case it's undefined
      cell.currentFteSum = fteSum;

      if (prefillWithIntersectingFte && cell.defaultedValue !== fteSum) {
        cell.defaultedValue = fteSum;
      }

      lineItemTotalFtes[index] += fteSum;
      summedTotalFtes[index] += fteSum;
    });
  });

  grouping.summedTotalFtes = summedTotalFtes;
  grouping.lineItemTotalFtes = lineItemTotalFtes;

  return summedTotalFtes;
};

const updateIntersectingFteSumForDateRanges = (state, action) => {
  const { dynamicModel } = state;
  const {
    columns,
    groupings,
    lookups: { cellLookup, lineItemLookup },
  } = dynamicModel;

  const { dataForRanges, prefillWithIntersectingFte, shouldHash } = action;

  if (!cellLookup) {
    return state;
  }

  forEach(dataForRanges, (data) => {
    const { id, fte, members } = data;

    const cellId = `macro-allocation-${id}`;
    const cell = cellLookup[cellId];

    if (!cell) {
      return;
    }

    cell.currentFteSum = roundFte(fte);

    // Add members inside the date range
    cell.members = members;
    cell.lineItem.isFteSumLoaded = true;

    // If flag enabled, use current fte sum as defaultedValue
    if (
      prefillWithIntersectingFte &&
      cell.defaultedValue !== cell.currentFteSum
    ) {
      cell.defaultedValue = cell.currentFteSum;
    }
  });

  // Set isFteSumLoaded for all line items
  forEach(lineItemLookup, (lineItem) => {
    lineItem.isFteSumLoaded = true;
  });

  // When dataForRanges is empty, just update the line items, skip grouping update
  if (isEmpty(dataForRanges)) {
    return state;
  }

  forEach(groupings, (grouping) => {
    setGroupingTotalFteSum(grouping, columns, prefillWithIntersectingFte);

    if (prefillWithIntersectingFte) {
      setGroupingWithCalculatedSumTotals(grouping, columns);
    }

    if (shouldHash) {
      hashGrouping(grouping);
    }
  });

  return {
    ...state,
  };
};

export default updateIntersectingFteSumForDateRanges;
